import { render, staticRenderFns } from "./BatchRunWeekList.vue?vue&type=template&id=0d96fd8c&scoped=true"
import script from "./BatchRunWeekList.vue?vue&type=script&lang=js"
export * from "./BatchRunWeekList.vue?vue&type=script&lang=js"
import style0 from "./BatchRunWeekList.vue?vue&type=style&index=0&id=0d96fd8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96fd8c",
  null
  
)

export default component.exports